import { createRouter, createWebHistory } from "vue-router";
import store from "@/store/index";
import Cookies  from 'vue-cookies';
import {requireAcademicsAdmin} from "@/router/academicsGuard";
import grades from "@/components/exam/grades.vue";
import subjectgroups from "@/components/exam/subjectgroups.vue";
import examcategories from "@/components/exam/examcategories.vue";
import requiredsubs from "@/components/exam/requiredsubs.vue";
import reportdates from "@/components/exam/reportdates.vue";
import reportcolours from "@/components/exam/reportcolours.vue";
import Academicssettings from "@/components/exam/academicssettings.vue";
import Schoolstamp from "@/components/exam/schoolstamp.vue";

const routes = [

  {
    path: "/superadmin",
    name: "AdminDashboard",
    component: () => import( "../components/superadmin/schools.vue"),
    meta: { requiresAuth: true },
  },

  {
    path: "/superUsers",
    name: "SuperUsers",
    component: () => import( "../components/superadmin/Users.vue"),
    meta: { requiresAuth: false },
  },

  {
    path: "/branches",
    name: "Branches",
    component: () => import( "../components/superadmin/Branches.vue"),
    meta: { requiresAuth: false },
  },

  {
    path: "/superadmin/reports",
    name: "SchoolsReport",
    component: () => import( "../components/superadmin/reports.vue"),
    meta: { requiresAuth: true },
  },

  {
    path: "/branches/schools/:id",
    name: "BranchSchools",
    component: () => import( "../components/superadmin/branchSchools.vue"),
    meta: { requiresAuth: false },
  },

  {
    path: "/branches/users/:id",
    name: "BranchUsers",
    component: () => import( "../components/superadmin/BranchUsers.vue"),
    meta: { requiresAuth: false },
  },

  {
    path: "/",
    name: "/",
    component: () => import( "../components/signin.vue"),
    meta: { requiresAuth: false },
  },

  {
    path: "/reset",
    name: "Reset",
    component: () => import( "../components/ResetPassword.vue"),
    meta: { requiresAuth: false },
  },

  {
    path: "/resetOtp",
    name: "ResetWithOtp",
    component: () => import( "../components/ResetWithOtp.vue"),
    meta: { requiresAuth: false },
  },

  {
    path: "/home",
    name: "Home",
    component: () => import( "../components/index.vue"),
    meta: { requiresAuth: true },
    beforeEnter: (to, from, next) => {
      const useOTPToLogin = localStorage.getItem("useOTPToLogin") === "true";
      const loginOtpVerified = localStorage.getItem("loginOtpVerified") === "true";
      if (useOTPToLogin && !loginOtpVerified) {
        console.log("Redirecting to OTP page...");
        next({
          path: "/login/otp",
          query: { redirect: to.fullPath } // keep track of original destination
        });
      } else {
        next(); // proceed normally
      }
    }
  },
  {
    path: "/login/otp",
    name: "LoginOtp",
    component: () => import("../components/OtpVerify.vue"),
    meta: {
      requiresAuth: true,
      beforeEnter: (to, from, next) => {
        next()
      }

    },
  },

  {
    path: "/registration",
    name: "Registration",
    component: () => import("../components/registration/registration.vue"),
    meta: { requiresAuth: true ,requiresRoles: ['ROLE_All', 'ROLE_Admissions_Admin',
        'ROLE_Issue_Leaveout_or_Suspension', 'ROLE_Add_or_Edit_students_and_Teachers']},
  },{
    path: '/events/editor/:id?', // The '?' makes the ID optional
    name: 'EventEditor',
    component: () => import("../components/EventEditor.vue"),
    meta: { requiresAuth: true ,requiresRoles: ['ROLE_All', 'ROLE_Send_Custom_sms']},
  },
  {
    path: "/students",
    name: "RegStudents",
    component: () => import("../components/registration/students.vue"),
    meta: { requiresAuth: true ,requiresRoles: ['ROLE_All', 'ROLE_Admissions_Admin',
        'ROLE_Issue_Leaveout_or_Suspension', 'ROLE_Add_or_Edit_students_and_Teachers']},
  },

  {
    path: "/transfers",
    name: "Transfers",
    component: () => import("../components/registration/transfers.vue"),
    meta: { requiresAuth: true ,requiresRoles: ['ROLE_All', 'ROLE_Admissions_Admin',
        'ROLE_Add_or_Edit_students_and_Teachers']},
  },
  {
    path: "/classes",
    name: "RegistrationClasses",
    component: () => import("../components/registration/classes.vue"),
    meta: { requiresAuth: true ,requiresRoles: ['ROLE_All', 'ROLE_Admissions_Admin',
        'ROLE_Add_or_Edit_students_and_Teachers']},
  },
  {
    path: "/teachers",
    name: "RegTeachers",
    component: () => import("../components/registration/teachers.vue"),
    meta: { requiresAuth: true ,requiresRoles: ['ROLE_All', 'ROLE_Admissions_Admin',
        'ROLE_Add_or_Edit_students_and_Teachers'] },
  },
  {
    path: "/staff",
    name: "RegStaff",
    component: () => import("../components/registration/staff.vue"),
    meta: { requiresAuth: true ,requiresRoles: ['ROLE_All', 'ROLE_Admissions_Admin',
        'ROLE_Add_or_Edit_students_and_Teachers'] },
  },
  {
    path: "/board",
    name: "Board",
    component: () => import("../components/registration/board.vue"),
    meta: { requiresAuth: true ,requiresRoles: ['ROLE_All', 'ROLE_Admissions_Admin',
        'ROLE_Add_or_Edit_students_and_Teachers'] },
  },
  {
    path: "/leaveouts",
    name: "leaveouts",
    component: () => import("../components/registration/leaveouts.vue"),
    meta: { requiresAuth: true ,requiresRoles: ['ROLE_All', 'ROLE_Admissions_Admin',
        'ROLE_Issue_Leaveout_or_Suspension', 'ROLE_Add_or_Edit_students_and_Teachers'] },
  },


      // In src/router/index.js, in the routes array:
    {
      path: '/reports',
      name: 'reports',
      component: () => import('@/components/registration/leaveouts.vue'),  // example pattern
    },

    {
  path: '/reports',
  name: 'RegistrationReports',
  component: () => import('@/components/registration/reports.vue'),
},



  {
    path: "/finance",
    name: "Finance",
    component: () => import("../components/finance/finance.vue"),
    meta: {
      requiresAuth: true,
      requiresRoles: [
        'ROLE_All',
        'ROLE_finance_admin',
        'ROLE_Access_Pocket_Money',
        'ROLE_View_Dalily_Collections',
        'ROLE_Access_Other_Sources_of_income',
        'ROLE_Approve_Refund',
        'ROLE_Send_Fee_balances',
        'ROLE_Access_Expenses',
        'ROLE_Cross_Receipts',
        'ROLE_Set_Fee_Structure',
        'ROLE_Access_Accounts_dashboard',
        'ROLE_Pay_Fees',
        'ROLE_Process_Refund',
        'ROLE_View_Only'
      ]
    },
    beforeEnter: (to, from, next) => {
      const useOTPToAccessFinance = localStorage.getItem("useOTPToAccessFinance") === "true";
      const verified = localStorage.getItem("financeOtpVerified") === "true";

      if (useOTPToAccessFinance && !verified) {
        console.log("Redirecting to OTP page...");
        sessionStorage.setItem("otpRequested", "true");
        next({
          path: "/finance/otp",
          query: { redirect: to.fullPath } // keep track of original destination
        });
      } else {
        next(); // proceed normally
      }
    }
  },

  {
    path: "/finance/otp",
    name: "FinanceOtp",
    component: () => import("../components/finance/OtpVerify.vue"),
    meta: {
      requiresAuth: true,
      requiresRoles: [
        'ROLE_All',
        'ROLE_finance_admin',
        'ROLE_Access_Pocket_Money',
        'ROLE_View_Dalily_Collections',
        'ROLE_Access_Other_Sources_of_income',
        'ROLE_Approve_Refund',
        'ROLE_Send_Fee_balances',
        'ROLE_Access_Expenses',
        'ROLE_Cross_Receipts',
        'ROLE_Set_Fee_Structure',
        'ROLE_Access_Accounts_dashboard',
        'ROLE_Pay_Fees',
        'ROLE_Process_Refund',
        'ROLE_View_Only'
      ],
      beforeEnter: (to, from, next) => {
        const requested = sessionStorage.getItem("otpRequested")
        console.log(requested)
        if (!requested) {
          next("/") // deny direct access
        } else {
          sessionStorage.removeItem("otpRequested") // one-time only
          next()
        }
      }

    },
  },

  {
    path: "/finance/settings",
    name: "FinanceSettings",
    component: () => import("../components/finance/financesettings.vue"),
    meta: { requiresAuth: true, requiresRoles: ['ROLE_All', 'ROLE_finance_admin'] },
  },

  {
    path: "/finance/stamp",
    name: "FinanceStamp",
    component: () => import("../components/finance/financestamp.vue"),
    meta: { requiresAuth: true, requiresRoles: ['ROLE_All', 'ROLE_finance_admin'] },
  },

  {
    path: "/financestudents",
    name: "FinStudents",
    component: () => import("../components/finance/students.vue"),
    meta: { requiresAuth: true ,requiresRoles: [
        'ROLE_All'
        , 'ROLE_finance_admin'
        , 'ROLE_Cross_Receipts'
        , 'ROLE_Set_Fee_Structure'
        , 'ROLE_Access_Accounts_dashboard'
        , 'ROLE_Send_Fee_balances'
        , 'ROLE_Pay_Fees'
        , 'ROLE_View_Only']},
  },

  {
    path: "/budgets",
    name: "Budgets",
    component: () => import( "../components/finance/budgets.vue"),
    meta: { requiresAuth: true ,requiresRoles: ['ROLE_All'
        , 'ROLE_create_budget','ROLE_View_Only','ROLE_finance_admin'] },
  },

  {
    path: "/BankReconciliation",
    name: "BankReconciliation",
    component: () => import( "../components/finance/BankReconciliation.vue"),
    meta: { requiresAuth: true ,requiresRoles: ['ROLE_All'
        , 'ROLE_create_budget','ROLE_View_Only','ROLE_finance_admin'] },
  },

  {
    path: "/refunds",
    name: "Refunds",
    component: () => import( "../components/finance/feerefunds.vue"),
    meta: { requiresAuth: true ,requiresRoles: ['ROLE_All', 'ROLE_Process_Refund',
        'ROLE_Approve_Refund','ROLE_View_Only','ROLE_finance_admin'] },
  },

  {
    path: "/feestructures",
    name: "FeeStructures",
    component: () => import( "../components/finance/feestructures.vue"),
    meta: { requiresAuth: true ,requiresRoles: ['ROLE_All','ROLE_View_Only',
        'ROLE_Set_Fee_Structure','ROLE_finance_admin'] },
  },

  {
    path: '/finance/student-collections',
    name: 'StudentCollections',
    component: () => import('@/components/finance/studentcollections.vue'),
    meta: { requiresAuth: true ,requiresRoles: ['ROLE_All', 'ROLE_Process_Refund',
    'ROLE_Approve_Refund','ROLE_View_Only','ROLE_finance_admin', 'ROLE_Pay_Fees'] },
  },

  {
    path: "/TermSetup",
    name: "TermSetup",
    component: () => import( "../components/finance/TermSetup.vue"),
    meta: { requiresAuth: true ,requiresRoles: ['ROLE_All','ROLE_View_Only',
        'ROLE_Set_Fee_Structure','ROLE_finance_admin'] },
  },

  {
    path: "/YearEndClose",
    name: "YearEndClose",
    component: () => import( "../components/finance/YearEndClose.vue"),
    meta: { requiresAuth: true ,requiresRoles: ['ROLE_All','ROLE_View_Only',
        'ROLE_Set_Fee_Structure','ROLE_finance_admin'] },
  },


  {
    path: "/AccountGroups",
    name: "AccountGroups",
    component: () => import( "../components/finance/AccountGroups.vue"),
    meta: { requiresAuth: true ,requiresRoles: ['ROLE_All','ROLE_View_Only',
        'ROLE_Set_Fee_Structure','ROLE_finance_admin'] },
  },


  {
    path: "/ManualJournal",
    name: "ManualJournal",
    component: () => import( "../components/finance/ManualJournal.vue"),
    meta: { requiresAuth: true ,requiresRoles: ['ROLE_All','ROLE_View_Only',
        'ROLE_Set_Fee_Structure','ROLE_finance_admin'] },
  },


  {
    path: "/billbyexcel",
    name: "billbyexcel",
    component: () => import( "../components/finance/billbyexcel.vue"),
    meta: { requiresAuth: true ,requiresRoles: ['ROLE_All','ROLE_View_Only',
        'ROLE_Set_Fee_Structure','ROLE_finance_admin'] },
  },


  {
    path: "/supliers",
    name: "Supliers",
    component: () => import( "../components/finance/supliers.vue"),
    meta: { requiresAuth: true ,requiresRoles: ['ROLE_All', 'ROLE_Access_Expenses',
        'ROLE_View_Only','ROLE_finance_admin'] },
  },



  {
    path: '/groupreceipts',
    name: 'GroupReceipts',
    component: () => import("../components/finance/GroupReceipts.vue"),
    meta: { requiresAuth: true ,requiresRoles: ['ROLE_All', 'ROLE_Access_Expenses',
        'ROLE_View_Only','ROLE_finance_admin'] },
  },


  {
    path: "/paymentvouchers",
    name: "Pvs",
    component: () => import( "../components/finance/pvs.vue"),
    meta: { requiresAuth: true ,requiresRoles: ['ROLE_All', 'ROLE_Access_Expenses',
        'ROLE_View_Only','ROLE_finance_admin'] },
  },



  {
    path: "/FinancialReports",
    name: "FinancialReports",
    component: () => import( "../components/finance/FinancialReports.vue"),
    meta: { requiresAuth: true ,requiresRoles: ['ROLE_All','ROLE_View_Only','ROLE_finance_admin'] },
  },


  {
    path: "/AuditTrail",
    name: "AuditTrail",
    component: () => import( "../components/finance/AuditTrail.vue"),
    meta: { requiresAuth: true ,requiresRoles: ['ROLE_All','ROLE_View_Only','ROLE_finance_admin'] },
  },


  {
    path: "/studentbilling",
    name: "studentbilling",
    component: () => import( "../components/finance/studentbilling.vue"),
    meta: { requiresAuth: true ,requiresRoles: ['ROLE_All', 'ROLE_Set_Fee_Structure',
        'ROLE_View_Only','ROLE_finance_admin'] },
  },


  {
    path: "/otherincomes",
    name: "OtherIncomes",
    component: () => import( "../components/finance/otherincomes.vue"),
    meta: { requiresAuth: true ,requiresRoles: ['ROLE_All','ROLE_finance_admin',
        'ROLE_View_Only','ROLE_Access_Other_Sources_of_income'] },
  },

  {
    path: "/banks",
    name: "BankAccounts",
    component: () => import( "../components/finance/bankaccounts.vue"),
    meta: { requiresAuth: true ,requiresRoles: ['ROLE_All','ROLE_finance_admin',
        'ROLE_View_Only'] },
  },

  {
    path: "/chartofaccounts",
    name: "ChartofAccounts",
    component: () => import( "../components/finance/chartofaccounts.vue"),
    meta: { requiresAuth: true ,requiresRoles: ['ROLE_All','ROLE_finance_admin', 'ROLE_View_Only'] },
  },

  {
    path: "/balancenotifications",
    name: "BalanceNotifications",
    component: () => import( "../components/finance/sendfeebals.vue"),
    meta: { requiresAuth: true ,requiresRoles: ['ROLE_All','ROLE_finance_admin', 'ROLE_Send_Fee_balances'] },
  },

  {
    // Old send path kept as a redirect so existing links/bookmarks still work.
    // The sent-jobs cards + send modal now live on /balancenotifications itself.
    path: "/balancenotifications/send",
    name: "BalanceNotificationsSend",
    redirect: { name: "BalanceNotifications" },
  },

  {
    path: "/receiptNotifications",
    name: "ReceiptNotifications",
    component: () => import( "../components/finance/NotificationMessages.vue"),
    props: {
      type: 'FEE RECEIPT',
      title: 'Receipt Notifications',
      detailTitle: 'Receipt Message',
      emptyTitle: 'No receipt messages found',
      emptySubtitle: 'Receipt SMS messages sent to parents after payment will appear here',
      // Receipts are sent automatically per payment (no batch jobs), so this
      // page lists individual sent SMS, searchable, with a click-to-detail view.
      messageListMode: true,
      messageType: 'FEE RECEIPT',
    },
    meta: { requiresAuth: true ,requiresRoles: ['ROLE_All','ROLE_finance_admin', 'ROLE_Send_Fee_balances'] },
  },

  {
    path: "/invoicenotifications",
    name: "InvoiceNotifications",
    component: () => import( "../components/finance/sendfeeinvoices.vue"),
    meta: { requiresAuth: true ,requiresRoles: ['ROLE_All','ROLE_finance_admin', 'ROLE_Send_Fee_balances'] },
  },

  {
    // Old send path kept as a redirect so existing links/bookmarks still work.
    path: "/invoicenotifications/send",
    name: "InvoiceNotificationsSend",
    redirect: { name: "InvoiceNotifications" },
  },

  {
    path: "/messages/templates",
    name: "MessageTemplates",
    component: () => import( "../components/finance/MessageTemplates.vue"),
    meta: { requiresAuth: true ,requiresRoles: ['ROLE_All','ROLE_finance_admin','ROLE_Send_Fee_balances'] },
  },

  {
    path: "/fee-reminders",
    name: "FeeReminders",
    component: () => import("../components/finance/FeeReminders.vue"),
    meta: { requiresAuth: true, requiresRoles: ['ROLE_All','ROLE_finance_admin','ROLE_Send_Fee_balances','ROLE_Print_Fee_Statement'] },
  },


  {
    path: "/feepayments",
    name: "Receipts",
    component: () => import( "../components/finance/receipts.vue"),
    meta: { requiresAuth: true ,requiresRoles: ['ROLE_All','ROLE_finance_admin',
        'ROLE_View_Only','ROLE_Pay_Fees'] },
  },


  {
    path: "/unreconciledreceipts",
    name: "UnreconciledPayments",
    component: () => import( "../components/finance/UnreconciledPayments.vue"),
    meta: { requiresAuth: true ,requiresRoles: ['ROLE_All','ROLE_finance_admin',
        'ROLE_View_Only','ROLE_Pay_Fees'] },
  },

  {
    path: "/feebalances",
    name: "Balances",
    component: () => import( "../components/finance/balances.vue"),
    meta: { requiresAuth: true ,requiresRoles: ['ROLE_All','ROLE_finance_admin',
        'ROLE_Send_Fee_balances','ROLE_View_Only','ROLE_Pay_Fees'] },
  },

  {
    path: "/pocketmoney",
    name: "pocketmoney",
    component: () => import("../components/finance/pocketmoney.vue"),
    meta: { requiresAuth: true ,requiresRoles: [
        'ROLE_All'
        , 'ROLE_finance_admin'
        , 'ROLE_Access_Pocket_Money'
        , 'ROLE_View_Only']},
  },







  {
    path: "/academics/grades",
    name: "Grades",
    component: grades,
    beforeEnter: requireAcademicsAdmin,
    meta: { requiresRole: "ROLE_Exam_admin" },
  },
  {
    path: "/academics/subject-groups",
    name: "SubjectGroups",
    component: subjectgroups,
    beforeEnter: requireAcademicsAdmin,
    meta: { requiresRole: "ROLE_Exam_admin" },
  },
  {
    path: "/academics/exam-categories",
    name: "ExamCategories",
    component: examcategories,
    beforeEnter: requireAcademicsAdmin,
    meta: { requiresRole: "ROLE_Exam_admin" },
  },
  {
    path: "/academics/required-subs",
    name: "RequiredSubs",
    component: requiredsubs,
    beforeEnter: requireAcademicsAdmin,
    meta: { requiresRole: "ROLE_Exam_admin" },
  },
  {
    path: "/academics/report-dates",
    name: "ReportDates",
    component: reportdates,
    beforeEnter: requireAcademicsAdmin,
    meta: { requiresRole: "ROLE_Exam_admin" },
  },
  {
    path: "/academics/report-colours",
    name: "ReportColours",
    component: reportcolours,
    beforeEnter: requireAcademicsAdmin,
    meta: { requiresRole: "ROLE_Exam_admin" },
  },
  {
    path: "/academics/settings",
    name: "AcademicsSettings",
    component: Academicssettings,
    // beforeEnter: requireAcademicsAdmin,  // import from './academicsGuard'
    meta: { requiresRole: "ROLE_Exam_admin" },
  },
  {
    path: "/academics/exam-results/send",
    name: "ExamResultsSend",
    component: () => import("../components/exam/sendexamresults.vue"),
    // beforeEnter: requireAcademicsAdmin,
    meta: { requiresAuth: true, requiresRoles: ['ROLE_All', 'ROLE_Super_Admin', 'ROLE_Exam_admin', 'ROLE_Send_Exam_Results', 'ROLE_CODING_ADMIN'] },
  },
  {
    path: "/academics/stamp",
    name: "SchoolStamp",
    component: Schoolstamp,
    // beforeEnter: requireAcademicsAdmin,
    meta: { requiresRole: "ROLE_Exam_admin" },
  },

  // ─── Pending Pass 2b pages ──────────────────────────────────────────
  // Uncomment as each ships. All admin-only (Settings submenu).
  //
  // {
  //   path: "/academics/subjects",
  //   name: "Subjects",
  //   component: SubjectsPage,
  //   beforeEnter: requireAcademicsAdmin,
  //   meta: { requiresRole: "ROLE_Exam_admin" },
  // },
  // {
  //   path: "/academics/remarks",
  //   name: "Remarks",
  //   component: RemarksPage,
  //   beforeEnter: requireAcademicsAdmin,
  //   meta: { requiresRole: "ROLE_Exam_admin" },
  // },
  // {
  //   path: "/academics/grading-system",
  //   name: "GradingSystem",
  //   component: GradingSystemPage,
  //   beforeEnter: requireAcademicsAdmin,
  //   meta: { requiresRole: "ROLE_Exam_admin" },
  // },

  // ─── Admin top-level pages ──────────────────────────────────────────
  // These still use the legacy Vue files — routes shown here with
  // their correct guards. Replace components when the pages are
  // migrated in Pass 3/4.
  //
  // {
  //   path: "/academics/dashboard",
  //   name: "ExamDash",
  //   component: ExamDashPage,
  //   beforeEnter: requireAcademicsAdmin,
  // },
  // {
  //   path: "/academics/exams",
  //   name: "Exams",
  //   component: ExamsPage,
  //   beforeEnter: requireAcademicsAdmin,
  // },

  // ─── Teacher + Admin pages ──────────────────────────────────────────
  // These are visible to anyone with EITHER academics role.
  //
  // {
  //   path: "/academics/my-subjects",
  //   name: "MySubjects",
  //   component: MySubjectsPage,
  //   beforeEnter: requireAcademicsAccess,
  // },
  // {
  //   path: "/academics/my-exams",
  //   name: "MyExams",
  //   component: MyExamsPage,
  //   beforeEnter: requireAcademicsAccess,
  // },
  // {
  //   path: "/academics/termly-conduct",
  //   name: "TermlyConduct",
  //   component: TermlyConductPage,
  //   beforeEnter: requireAcademicsAccess,
  // },


  {
    path: "/dashboard",
    name: "ExamDash",
    component: () => import(/* webpackChunkName: "ExamDash" */ "../components/exam/dashboard.vue"),
    meta: { requiresAuth: true ,requiresRoles: ['ROLE_All', 'ROLE_Exam_admin',
        'ROLE_Access_Exam_Analysis_Module'] },
  },
  {
    path: "/exams",
    name: "Exams",
    component: () => import(/* webpackChunkName: "Exams" */ "../components/exam/exams.vue"),
    meta: { requiresAuth: true ,requiresRoles: ['ROLE_All', 'ROLE_Exam_admin'] },
  },
  {
    path: "/mysubjects",
    name: "MySubjects",
    component: () => import( "../components/exam/mysubjects.vue"),
    meta: { requiresAuth: true ,requiresRoles: ['ROLE_All','ROLE_Exam_admin', 'ROLE_Access_Exam_Analysis_Module',
        'ROLE_Exam_admin'] },
  },

  {
    path: "/academics/marks/:examId/:subjectId",
    name: "MarksSheet",
    component: () => import("../components/exam/markssheet.vue"),
    props: true,
    meta: {
      requiresAuth: true,
      requiresRoles: ['ROLE_All', 'ROLE_Exam_admin', 'ROLE_Access_Exam_Analysis_Module']
    },
  },

  {
    path: "/academics/marks-admin/:examId",
    name: "MarksSheetAdmin",
    component: () => import("../components/exam/markssheetadmin.vue"),
    props: true,
    meta: {
      requiresAuth: true,
      requiresRoles: ['ROLE_All', 'ROLE_Exam_admin']
    },
  },

  {
    path: "/academics/exam-analysis/:examId",
    name: "ExamAnalysis",
    component: () => import("../components/exam/ExamAnalysis.vue"),
    props: true,
    meta: {
      requiresAuth: true,
      requiresRoles: ['ROLE_All', 'ROLE_Exam_admin', 'ROLE_Access_Exam_Analysis_Module']
    },
  },

  {
    path: "/termlyconduct",
    name: "TermlyConduct",
    component: () => import( "../components/exam/TermlyConduct.vue"),
    meta: { requiresAuth: true ,requiresRoles: ['ROLE_All','ROLE_Exam_admin', 'ROLE_Access_Exam_Analysis_Module'] },
  },

  {
    path: "/myexams",
    name: "MyExams",
    component: () => import( "../components/exam/myexams.vue"),
    meta: { requiresAuth: true ,requiresRoles: ['ROLE_All','ROLE_Exam_admin', 'ROLE_Access_Exam_Analysis_Module'] },
  },
  {
    path: "/grades",
    name: "Grades",
    component: () => import( "../components/exam/grades.vue"),
    meta: { requiresAuth: true ,requiresRoles: ['ROLE_All', 'ROLE_Exam_admin'] },
  },
  {
    path: "/subjects",
    name: "Subjects",
    component: () => import( "../components/exam/subjects.vue"),
    meta: { requiresAuth: true ,requiresRoles: ['ROLE_All', 'ROLE_Exam_admin'] },
  },
  {
    path: "/subjectgroups",
    name: "SubjectGroups",
    component: () => import( "../components/exam/subjectgroups.vue"),
    meta: { requiresAuth: true ,requiresRoles: ['ROLE_All', 'ROLE_Exam_admin'] },
  },
  {
    path: "/examcategories",
    name: "ExamCategories",
    component: () => import( "../components/exam/examcategories.vue"),
    meta: { requiresAuth: true ,requiresRoles: ['ROLE_All', 'ROLE_Exam_admin'] },
  },
  {
    path: "/remarks",
    name: "Remarks",
    component: () => import( "../components/exam/remarks.vue"),
    meta: { requiresAuth: true ,requiresRoles: ['ROLE_All', 'ROLE_Exam_admin'] },
  },
  {
    path: "/gradingsystem",
    name: "GradingSystem",
    component: () => import( "../components/exam/gradingsystem.vue"),
    meta: { requiresAuth: true ,requiresRoles: ['ROLE_All', 'ROLE_Exam_admin'] },
  },
  {
    path: "/requiredsubs",
    name: "RequiredSubs",
    component: () => import( "../components/exam/requiredsubs.vue"),
    meta: { requiresAuth: true ,requiresRoles: ['ROLE_All', 'ROLE_Exam_admin'] },
  },
  {
    path: "/reportdates",
    name: "ReportDates",
    component: () => import( "../components/exam/reportdates.vue"),
    meta: { requiresAuth: true ,requiresRoles: ['ROLE_All', 'ROLE_Exam_admin'] },
  },
  {
    path: "/reportcolours",
    name: "ReportColours",
    component: () => import( "../components/exam/reportcolours.vue"),
    meta: { requiresAuth: true ,requiresRoles: ['ROLE_All', 'ROLE_Exam_admin'] },
  },



  {
    path: "/sms",
    name: "sms",
    component: () => import( "../components/bulksms/sms.vue"),
    meta: { requiresAuth: true ,requiresRoles: ['ROLE_All', 'ROLE_Send_Custom_sms'] },
  },

  {
    path: "/smshistory",
    name: "smshistory",
    component: () => import( "../components/bulksms/smshistory.vue"),
    meta: { requiresAuth: true ,requiresRoles: ['ROLE_All', 'ROLE_Send_Custom_sms'] },
  },


  {
    path: "/newsms",
    name: "newsms",
    component: () => import( "../components/bulksms/newmessage.vue"),
    meta: { requiresAuth: true ,requiresRoles: ['ROLE_All', 'ROLE_Send_Custom_sms'] },
  },

  {
    path: "/noticeboard",
    name: "noticeboard",
    component: () => import( "../components/bulksms/notices.vue"),
    meta: { requiresAuth: true ,requiresRoles: ['ROLE_All', 'ROLE_Send_Custom_sms'] },
  },

  {
    path: "/newsletters",
    name: "newsletters",
    component: () => import( "../components/bulksms/newsletters.vue"),
    meta: { requiresAuth: true ,requiresRoles: ['ROLE_All', 'ROLE_Send_Custom_sms'] },
  },




// timetable
  {
    path: "/timetable/dashboard",
    name: "Timetable",
    component: () => import(/* webpackChunkName: "Hr" */ "../components/timetable/Main.vue"),
    meta: {requiresAuth: true ,requiresRoles: ['ROLE_All', 'ROLE_timetable_admin'] },
  },

  {
    path: "/timetable/subjects",
    name: "SubjectsTT",
    component: () => import("../components/timetable/Subjects.vue"),
    meta: {requiresAuth: true ,requiresRoles: ['ROLE_All', 'ROLE_timetable_admin'] },
  },

  {
    path: "/timetable/classes",
    name: "ClassesTT",
    component: () => import(/* webpackChunkName: "Hr" */ "../components/timetable/Classes"),
    meta: {requiresAuth: true ,requiresRoles: ['ROLE_All', 'ROLE_timetable_admin'] },
  },
  {
    path: "/timetable/rooms",
    name: "Rooms",
    component: () => import("../components/timetable/Rooms.vue"),
    meta: {requiresAuth: true ,requiresRoles: ['ROLE_All', 'ROLE_timetable_admin'] },
  },
  {
    path: "/timetable/teachers",
    name: "Teachers",
    component: () => import("../components/timetable/Teachers.vue"),
    meta: {requiresAuth: true ,requiresRoles: ['ROLE_All', 'ROLE_timetable_admin'] },
  },
  {
    path: "/timetable/timetables",
    name: "Timetables",
    component: () => import("../components/timetable/Timetables.vue"),
    meta: {requiresAuth: true ,requiresRoles: ['ROLE_All', 'ROLE_timetable_admin'] },
  },
  {
    path: "/timetable/timeslots",
    name: "Timeslots",
    component: () => import("../components/timetable/Timeslots.vue"),
    meta: {requiresAuth: true ,requiresRoles: ['ROLE_All', 'ROLE_timetable_admin'] },
  },
  {
    path: "/timetable/days",
    name: "Days",
    component: () => import("../components/timetable/Days.vue"),
    meta: {requiresAuth: true ,requiresRoles: ['ROLE_All', 'ROLE_timetable_admin'] },
  },
  {
    path: "/timetable/tags",
    name: "Tags",
    component: () => import("../components/timetable/Tags.vue"),
    meta: {requiresAuth: true ,requiresRoles: ['ROLE_All', 'ROLE_timetable_admin'] },
  },
  {
    path: "/timetable/lessons",
    name: "Lessons",
    component: () => import("../components/timetable/Lessons.vue"),
    meta: {requiresAuth: true ,requiresRoles: ['ROLE_All', 'ROLE_timetable_admin'] },
  },
  {
    path: "/timetable/subs",
    name: "Subs",
    component: () => import("../components/timetable/Subs.vue"),
    meta: {requiresAuth: true ,requiresRoles: ['ROLE_All', 'ROLE_timetable_admin'] },
  },
  {
    path: "/timetable/teacherStatistics",
    name: "TeacherStatistics",
    component: () => import("../components/timetable/TeacherStatistics.vue"),
    meta: {requiresAuth: true ,requiresRoles: ['ROLE_All', 'ROLE_timetable_admin'] },
  },
  {
    path: "/timetable/classStatistics",
    name: "ClassStatistics",
    component: () => import("../components/timetable/ClassStatistics.vue"),
    meta: {requiresAuth: true ,requiresRoles: ['ROLE_All', 'ROLE_timetable_admin'] },
  },
  {
    path: "/timetable/roomStatistics",
    name: "RoomStatistics",
    component: () => import("../components/timetable/RoomStatistics.vue"),
    meta: {requiresAuth: true ,requiresRoles: ['ROLE_All', 'ROLE_timetable_admin'] },
  },
  {
    path: "/timetable/subjectStatistics",
    name: "SubjectStatistics",
    component: () => import("../components/timetable/SubjectStatistics.vue"),
    meta: {requiresAuth: true ,requiresRoles: ['ROLE_All', 'ROLE_timetable_admin'] },
  },
  {
    path: "/timetable/lessons/new",
    name: "AddLesson",
    component: () => import("../components/timetable/AddLesson.vue"),
    meta: {requiresAuth: true ,requiresRoles: ['ROLE_All', 'ROLE_timetable_admin'] },
  },
  {
    path: "/timetable/subjectLessons/:id",
    name: "SubjectLessons",
    component: () => import("../components/timetable/SubjectLessons.vue"),
    meta: {requiresAuth: true ,requiresRoles: ['ROLE_All', 'ROLE_timetable_admin'] },
  },
  {
    path: "/timetable/subjectTimeoffs/:id",
    name: "SubjectTimeoffs",
    component: () => import("../components/timetable/SubjectTimeoffs.vue"),
    meta: {requiresAuth: true ,requiresRoles: ['ROLE_All', 'ROLE_timetable_admin'] },
  },
  {
    path: "/timetable/roomLessons/:id",
    name: "RoomLessons",
    component: () => import("../components/timetable/RoomLessons.vue"),
    meta: {requiresAuth: true ,requiresRoles: ['ROLE_All', 'ROLE_timetable_admin'] },
  },
  {
    path: "/timetable/roomTimeoffs/:id",
    name: "RoomTimeoffs",
    component: () => import("../components/timetable/RoomTimeoffs.vue"),
    meta: {requiresAuth: true ,requiresRoles: ['ROLE_All', 'ROLE_timetable_admin'] },
  },
  {
    path: "/timetable/classLessons/:id",
    name: "ClassLessons",
    component: () => import("../components/timetable/ClassLessons.vue"),
    meta: {requiresAuth: true ,requiresRoles: ['ROLE_All', 'ROLE_timetable_admin'] },
  },
  {
    path: "/timetable/classTimeoffs/:id",
    name: "ClassTimeoffs",
    component: () => import("../components/timetable/ClassTimeoffs.vue"),
    meta: {requiresAuth: true ,requiresRoles: ['ROLE_All', 'ROLE_timetable_admin'] },
  },

  {
    path: "/timetable/teacherLessons/:id",
    name: "TeacherLessons",
    component: () => import("../components/timetable/TeacherLessons.vue"),
    meta: {requiresAuth: true ,requiresRoles: ['ROLE_All', 'ROLE_timetable_admin'] },
  },
  {
    path: "/timetable/teacherTimeoffs/:id",
    name: "TeacherTimeoffs",
    component: () => import("../components/timetable/TeacherTimeoffs.vue"),
    meta: {requiresAuth: true ,requiresRoles: ['ROLE_All', 'ROLE_timetable_admin'] },
  },
  {
    path: "/timetable/lessons/edit/:id",
    name: "Editlesson",
    component: () => import("../components/timetable/EditLesson.vue"),
    meta: {requiresAuth: true ,requiresRoles: ['ROLE_All', 'ROLE_timetable_admin'] },
  },






  // INVENTORY
  {
    path: "/inventory/dashboard",
    name: "Inventory",
    component: () => import("../components/inventory/dashboard.vue"),
    meta: {requiresAuth: true},
  },
  {
    path: "/inventory/assets/dashboard",
    name: "FAInventory",
    component: () => import("../components/inventory/FixedAssetDashboard.vue"),
    meta: {requiresAuth: true},
  },
  {
    path: "/inventory/items",
    name: "Items",
    component: () => import("../components/inventory/items.vue"),
    meta: {requiresAuth: true},
  },
  {
    path: "/inventory/item/categories",
    name: "InventoryCategories",
    component: () => import("../components/inventory/InventoryCategories.vue"),
    meta: {requiresAuth: true},
  },{
    path: "/inventory/vendors/balances",
    name: "VendorBalances",
    component: () => import("../components/inventory/VendorBalances.vue"),
    meta: {requiresAuth: true},
  },
  {
    path: "/inventory/vendors",
    name: "Vendors",
    component: () => import("../components/inventory/vendors.vue"),
    meta: {requiresAuth: true},
  },
  {
    path: "/inventory/vendor/categories",
    name: "SupplyCategories",
    component: () => import("../components/inventory/SupplyCategories.vue"),
    meta: {requiresAuth: true},
  },
  {
    path: "/inventory/bills",
    name: "Bills",
    component: () => import("../components/inventory/bills.vue"),
    meta: {requiresAuth: true},
  },
  {
    path: "/inventory/adjustment",
    name: "Adjustment",
    component: () => import("../components/inventory/adjustment.vue"),
    meta: {requiresAuth: true},
  },
  {
    path: "/inventory/requisition",
    name: "Requisition",
    component: () => import("../components/inventory/requisition.vue"),
    meta: {requiresAuth: true},
  },
  {
    path: "/inventory/approval",
    name: "RequisitionApproval",
    component: () => import("../components/inventory/RequisitionApproval.vue"),
    meta: {requiresAuth: true},
  },
  {
    path: "/inventory/requisition/add",
    name: "AddRequisition",
    component: () => import("../components/inventory/newRequisition.vue"),
    meta: {requiresAuth: true},
  },
  {
    path: "/inventory/po",
    name: "PurchaseOrders",
    component: () => import("../components/inventory/purchase_orders.vue"),
    meta: {requiresAuth: true},
  },{
    path: "/inventory/overdue",
    name: "InventoryOverdue",
    component: () => import("../components/inventory/InventoryOverdue.vue"),
    meta: {requiresAuth: true},
  },{
    path: "/inventory/valuation",
    name: "InventoryValuation",
    component: () => import("../components/inventory/InventoryValuationReport.vue"),
    meta: {requiresAuth: true},
  },{
    path: "/inventory/department-consumption",
    name: "DepartmentConsumption",
    component: () => import("../components/inventory/DeptConsumptionReport.vue"),
    meta: {requiresAuth: true},
  },{
    path: "/inventory/Low-stock-items",
    name: "LowStockReport",
    component: () => import("../components/inventory/LowStockReport.vue"),
    meta: {requiresAuth: true},
  },
  {
    path: "/inventory/po/active",
    name: "ActivePurchaseOrders",
    component: () => import("../components/inventory/ActivePOs.vue"),
    meta: {requiresAuth: true},
  },
  {
    path: "/inventory/newPO",
    name: "NewPO",
    component: () => import("../components/inventory/newPurchaseOrder.vue"),
    meta: {requiresAuth: true},
  },
  {
    path: "/inventory/assets",
    name: "AssetManagement",
    component: () => import("../components/inventory/assetManagement.vue"),
    meta: {requiresAuth: true},
  },
  {
    path: "/inventory/assets/info/:id",
    name: "AssetInfo",
    component: () => import("../components/inventory/AssetInfo.vue"),
    meta: {requiresAuth: true},
  },
  {
    path: "/inventory/receive/:id",
    name: "ReceiveItems",
    component: () => import("../components/inventory/receiveItems.vue"),
    meta: {requiresAuth: true},
  },
  {
    path: "/inventory/payment/request",
    name: "PaymentRequest",
    component: () => import("../components/inventory/requestPayment.vue"),
    meta: {requiresAuth: true},
  },
  {
    path: "/inventory/items/issue",
    name: "IssueItems",
    component: () => import("../components/inventory/issueItems.vue"),
    meta: {requiresAuth: true},
  },
  {
    path: "/inventory/items/return",
    name: "ReturnItems",
    component: () => import("../components/inventory/returnItems.vue"),
    meta: {requiresAuth: true},
  },

  // LIBRARY
  {
    path: "/library/dashboard",
    name: "Library",
    component: () => import("../components/library/dashboard.vue"),
    meta: {requiresAuth: true},
  },
  {
    path: "/library/books",
    name: "Books",
    component: () => import("../components/library/books.vue"),
    meta: {requiresAuth: true},
  },
  {
    path: "/library/book/view/:id",
    name: "ViewBook",
    component: () => import("../components/library/viewBook.vue"),
    meta: {requiresAuth: true},
  },
  {
    path: "/library/fines",
    name: "Fines",
    component: () => import("../components/library/fines.vue"),
    meta: {requiresAuth: true},
  },
  {
    path: "/library/books/issue",
    name: "IssueBooks",
    component: () => import("../components/library/issueBooks.vue"),
    meta: {requiresAuth: true},
  },
  {
    path: "/library/books/return",
    name: "ReturnBooks",
    component: () => import("../components/library/returnBooks.vue"),
    meta: {requiresAuth: true},
  },






  //Biometrics

  {
    path: "/biometrics/dashboard",
    name: "Biometrics",
    component: () => import(/* webpackChunkName: "Biometrics" */ "../components/biometrics/dashboard.vue"),
    meta: { requiresAuth: true ,requiresRoles: ['ROLE_All','ROLE_biometrics_admin'] },
  },
  {
    path: "/biometrics/students",
    name: "Biostudents",
    component: () => import(/* webpackChunkName: "Biostudents" */ "../components/biometrics/Biostudents.vue"),
    meta: { requiresAuth: true ,requiresRoles: ['ROLE_All','ROLE_biometrics_admin'] },
  },

  {
    path: "/biometrics/teachers",
    name: "BioTeachers",
    component: () => import(/* webpackChunkName: "BioTeachers" */ "../components/biometrics/Bioteachers.vue"),
    meta: { requiresAuth: true ,requiresRoles: ['ROLE_All','ROLE_biometrics_admin'] },
  },

  {
    path: "/biometrics/staff",
    name: "BioStaff",
    component: () => import(/* webpackChunkName: "BioStaff" */ "../components/biometrics/Biostaff.vue"),
    meta: { requiresAuth: true ,requiresRoles: ['ROLE_All' ,'ROLE_biometrics_admin'] },
  },

  {
    path: "/biometrics/sentsms",
    name: "SentSms",
    component: () => import(/* webpackChunkName: "SentSms" */ "../components/biometrics/sentsms.vue"),
    meta: { requiresAuth: true ,requiresRoles: ['ROLE_All','ROLE_biometrics_admin'] },
  },

  {
    path: "/biometrics/classes",
    name: "Classes",
    component: () => import(/* webpackChunkName: "Classes" */ "../components/biometrics/Bioclasses.vue"),
    meta: { requiresAuth: true ,requiresRoles: ['ROLE_All', 'ROLE_biometrics_admin'
        ,'ROLE_biometrics_admin'] },
  },


  {
    path: "/biometrics/classregister",
    name: "Register",
    component: () => import(/* webpackChunkName: "Classes" */ "../components/biometrics/Register.vue"),
    meta: { requiresAuth: true ,requiresRoles: ['ROLE_All','ROLE_Mark_attendance_register','ROLE_biometrics_admin'] },
  },


  {
    path: "/biometrics/reasons",
    name: "Reasons",
    component: () => import(/* webpackChunkName: "Reasons" */ "../components/biometrics/reasons.vue"),
    meta: { requiresAuth: true ,requiresRoles: ['ROLE_All' ,'ROLE_biometrics_admin'] },
  },
  {
    path: "/biometrics/gadgets",
    name: "Gadgets",
    component: () => import(/* webpackChunkName: "Gadgets" */ "../components/biometrics/gadgets.vue"),
    meta: { requiresAuth: true ,requiresRoles: ['ROLE_All','ROLE_biometrics_admin'] },
  },
  {
    path: "/biometrics/settings",
    name: "BioSettings",
    component: () => import(/* webpackChunkName: "BioSettings" */ "../components/biometrics/biometricssettings.vue"),
    meta: { requiresAuth: true ,requiresRoles: ['ROLE_All','ROLE_biometrics_admin'] },
  },




  // Hr
  {
    path: "/hr",
    name: "Hr",
    component: () => import(/* webpackChunkName: "Hr" */ "../components/payroll/dashboard.vue"),
    meta: { requiresAuth: true ,requiresRoles: ['ROLE_All', 'ROLR_HR_ADMIN','ROLE_Add_or_Edit_Employee'] },
  },
  {
    path: "/employees",
    name: "Employees",
    component: () => import(/* webpackChunkName: "Employees" */ "../components/payroll/Employees.vue"),
    meta: { requiresAuth: true ,requiresRoles: ['ROLE_All', 'ROLR_HR_ADMIN','ROLE_Add_or_Edit_Employee'] },
  },
  {
    path: "/attendance",
    name: "Attendance",
    component: () => import(/* webpackChunkName: "Attendance" */ "../components/payroll/attendance.vue"),
    meta: { requiresAuth: true ,requiresRoles: ['ROLE_All', 'ROLR_HR_ADMIN','ROLE_Add_or_Edit_Employee'] },
  },
  {
    path: "/studentattendance/:id",
    name: "StudentAttendance",
    component: () => import(/* webpackChunkName: "StudentAttendance" */ "../components/biometrics/attendance.vue"),
    meta: { requiresAuth: true ,requiresRoles: ['ROLE_All', 'ROLR_HR_ADMIN','ROLE_Add_or_Edit_Employee'] },
  },
  {
    path: "/hrsettings",
    name: "Hrsettings",
    component: () => import(/* webpackChunkName: "Hrsettings" */ "../components/payroll/hrsettings.vue"),
    meta: { requiresAuth: true ,requiresRoles: ['ROLE_All', 'ROLR_HR_ADMIN','ROLE_Add_or_Edit_Employee'] },
  },
  {
    path: "/hrBanks",
    name: "HrBanks",
    component: () => import(/* webpackChunkName: "Hrsettings" */ "../components/payroll/HrBanks.vue"),
    meta: { requiresAuth: true ,requiresRoles: ['ROLE_All', 'ROLR_HR_ADMIN'] },
  },
  {
    path: "/payrolls",
    name: "Payrolls",
    component: () => import(/* webpackChunkName: "Payrolls" */ "../components/payroll/Payrolls.vue"),
    meta: { requiresAuth: true ,requiresRoles: ['ROLE_All', 'ROLR_HR_ADMIN','ROLE_Add_or_Edit_Employee'] },
  },
  {
    path: "/allowances",
    name: "Earnings",
    component: () => import(/* webpackChunkName: "Earnings" */ "../components/payroll/Earnings.vue"),
    meta: { requiresAuth: true ,requiresRoles: ['ROLE_All', 'ROLR_HR_ADMIN','ROLE_Add_or_Edit_Employee'] },
  },
  {
    path: "/taxbands",
    name: "Kra",
    component: () => import(/* webpackChunkName: "Kra" */ "../components/payroll/kra.vue"),
    meta: { requiresAuth: true ,requiresRoles: ['ROLE_All', 'ROLR_HR_ADMIN','ROLE_Add_or_Edit_Employee'] },
  },
  {
    path: "/nhifbands",
    name: "Nhif",
    component: () => import(/* webpackChunkName: "Nhif" */ "../components/payroll/nhif.vue"),
    meta: { requiresAuth: true ,requiresRoles: ['ROLE_All', 'ROLR_HR_ADMIN','ROLE_Add_or_Edit_Employee'] },
  },
  {
    path: "/nssfbands",
    name: "Nssf",
    component: () => import(/* webpackChunkName: "Nssf" */ "../components/payroll/nssf.vue"),
    meta: { requiresAuth: true ,requiresRoles: ['ROLE_All', 'ROLR_HR_ADMIN','ROLE_Add_or_Edit_Employee'] },
  },
  {
    path: "/housebands",
    name: "Housing",
    component: () => import(/* webpackChunkName: "Housing" */ "../components/payroll/housing.vue"),
    meta: { requiresAuth: true ,requiresRoles: ['ROLE_All', 'ROLR_HR_ADMIN','ROLE_Add_or_Edit_Employee'] },
  },
  {
    path: "/leave",
    name: "Leave",
    component: () => import(/* webpackChunkName: "Leave" */ "../components/payroll/leave.vue"),
    meta: { requiresAuth: true ,requiresRoles: ['ROLE_All', 'ROLR_HR_ADMIN','ROLE_Add_or_Edit_Employee'] },
  },
  {
    path: "/deductions",
    name: "Deductions",
    component: () => import(/* webpackChunkName: "Deductions" */ "../components/payroll/Deductions.vue"),
    meta: { requiresAuth: true ,requiresRoles: ['ROLE_All', 'ROLR_HR_ADMIN','ROLE_Add_or_Edit_Employee'] },
  },





  // Settings

  {
    path: "/settings",
    component: () => import(/* webpackChunkName: "Settings" */ "../components/settings/SettingsShell.vue"),
    meta: { requiresAuth: true ,requiresRoles: ['ROLE_All'] },
    children: [
      { path: "",           redirect: { name: "SettingsIdentity" } },
      { path: "identity",   name: "SettingsIdentity",   component: () => import("../components/settings/IdentitySettings.vue") },
      { path: "security",   name: "SettingsSecurity",   component: () => import("../components/settings/SecuritySettings.vue") },
      { path: "account",    name: "SettingsAccount",    component: () => import("../components/settings/AccountSettings.vue") },
      { path: "signatures", name: "SettingsSignatures", component: () => import("../components/settings/SignatureSettings.vue") },
      { path: "legacy",     name: "Settings",           redirect: { name: "SettingsIdentity" } },
    ],
  },

  {
    path: "/users",
    name: "Users",
    component: () => import(/* webpackChunkName: "Settings" */ "../components/settings/users.vue"),
    meta: { requiresAuth: true ,requiresRoles: ['ROLE_All'] },
  },


  {
    path: "/settingsclasses",
    name: "settingClasses",
    component: () => import(/* webpackChunkName: "Settings" */ "../components/settings/classes.vue"),
    meta: { requiresAuth: true ,requiresRoles: ['ROLE_All'] },
  },

  {
    path: "/settingstreams",
    name: "settingStreams",
    component: () => import(/* webpackChunkName: "Settings" */ "../components/settings/streams.vue"),
    meta: { requiresAuth: true ,requiresRoles: ['ROLE_All'] },
  },

  {
    path: "/courses",
    name: "Courses",
    component: () => import(/* webpackChunkName: "Settings" */ "../components/settings/courses.vue"),
    meta: { requiresAuth: true ,requiresRoles: ['ROLE_All'] },
  },

  {
    path: "/departments",
    name: "Departments",
    component: () => import(/* webpackChunkName: "Settings" */ "../components/settings/departments.vue"),
    meta: { requiresAuth: true ,requiresRoles: ['ROLE_All'] },
  },

  {
    path: "/terms",
    name: "Terms",
    component: () => import(/* webpackChunkName: "Settings" */ "../components/settings/terms.vue"),
    meta: { requiresAuth: true ,requiresRoles: ['ROLE_All'] },
  },

  {
    path: "/hostels",
    name: "Hostels",
    component: () => import(/* webpackChunkName: "Settings" */ "../components/settings/hostels.vue"),
    meta: { requiresAuth: true ,requiresRoles: ['ROLE_All'] },
  },








  // E-learning
  {
    path: "/E-learning",
    name: "E-learning",
    component: () => import(/* webpackChunkName: "Settings" */ "../components/Elearning/dashboard.vue"),
    meta: { requiresAuth: true ,requiresRoles: ['ROLE_All','ROLE_post_content','ROLE_Elearning_Admin'] },
  },

  {
    path: "/dashboard",
    name: "Dashboard",
    component: () => import(/* webpackChunkName: "Hr" */ "../components/Elearning/dashboard.vue"),
    meta: { requiresAuth: true ,requiresRoles: ['ROLE_All','ROLE_post_content','ROLE_Elearning_Admin']  },
  },

  {
    path: "/assignments",
    name: "Assignments",
    component: () => import(/* webpackChunkName: "Hr" */ "../components/Elearning/assignments.vue"),
    meta: { requiresAuth: true ,requiresRoles: ['ROLE_All','ROLE_post_content','ROLE_Elearning_Admin']  },
  },

  {
    path: "/selftests",
    name: "Selftests",
    component: () => import(/* webpackChunkName: "Hr" */ "../components/Elearning/assignments.vue"),
    meta: { requiresAuth: true ,requiresRoles: ['ROLE_All','ROLE_post_content','ROLE_Elearning_Admin']  },
  },

  {
    path: "/thinktank",
    name: "thinktank",
    component: () => import(/* webpackChunkName: "Hr" */ "../components/Elearning/revision.vue"),
    meta: { requiresAuth: true ,requiresRoles: ['ROLE_All','ROLE_post_content','ROLE_Elearning_Admin']   },
  },

  {
    path: "/videoclasses",
    name: "vodeoclasses",
    component: () => import(/* webpackChunkName: "Hr" */ "../components/Elearning/vodeoclasses.vue"),
    meta: { requiresAuth: true ,requiresRoles: ['ROLE_All','ROLE_post_content','ROLE_Elearning_Admin']   },
  },


  {
    path: "/liveclasses",
    name: "liveclasses",
    component: () => import(/* webpackChunkName: "Hr" */ "../components/Elearning/liveclasses.vue"),
    meta: { requiresAuth: true  ,requiresRoles: ['ROLE_All','ROLE_post_content','ROLE_Elearning_Admin']  },
  },

  {
    path: '/meeting/:meetingId',
    name: "meeting",
    component: () =>
        import(
            /* webpackChunkName: "Hr" */ "../components/Meeting.vue"
            ),
    meta: { requiresAuth: true },
    props: true
  },

  {
    path: "/pastpapers",
    name: "pastpapers",
    component: () => import(/* webpackChunkName: "Hr" */ "../components/Elearning/pastpapers.vue"),
    meta: { requiresAuth: true  ,requiresRoles: ['ROLE_Super_Admin', 'ROLE_CODING_ADMIN', 'ROLE_CODING_TEACHER']

    },
  },

  {
    path: "/notes",
    name: "notes",
    component: () => import(/* webpackChunkName: "Hr" */ "../components/Elearning/notes.vue"),
    meta: { requiresAuth: true  ,requiresRoles: ['ROLE_Super_Admin', 'ROLE_CODING_ADMIN', 'ROLE_CODING_TEACHER']
    },
  },

  {
    path: "/quizzes",
    name: "QuizzesModule",
    component: () => import("../components/Elearning/QuizzesModule.vue"),
    meta: { requiresAuth: true },
    children: [
      {
        path: "active", // /quizzes
        name: "Active Quizzes",
        component: () =>
            import("../components/Elearning/quizzes/ActiveQuizzes.vue"),
      },
      {
        path: "pending", // /quizzes/pending
        name: "Pending Quizzes",
        component: () =>
            import(
                "../components/Elearning/quizzes/PendingQuizzes.vue"
                ),
      },
      {
        path: "completed", // /quizzes/completed
        name: "Completed Quizzes",
        component: () =>
            import(
                "../components/Elearning/quizzes/CompletedQuizzes.vue"
                ),
      },
    ],
  },

  {
    path: "/quiz/:id",
    name: "QuizDetails",
    component: () =>
        import(
            /* webpackChunkName: "Quizzes" */ "../components/Elearning/quizzes/QuizDetails.vue"
            ),
    meta: { requiresAuth: true },
  },

  {
    path: "/topics",
    name: "topics",
    component: () => import(/* webpackChunkName: "Hr" */ "../components/Elearning/Topics.vue"),
    meta: { requiresAuth: true  ,requiresRoles: ['ROLE_Super_Admin', 'ROLE_CODING_ADMIN', 'ROLE_CODING_TEACHER']
    },
  },
  {
    path: "/tags",
    name: "tags",
    component: () => import(/* webpackChunkName: "Hr" */ "../components/Elearning/Tags.vue"),
    meta: { requiresAuth: true  ,requiresRoles: ['ROLE_Super_Admin', 'ROLE_CODING_ADMIN', 'ROLE_CODING_TEACHER']
    },
  },
  {
    path: "/genres",
    name: "genres",
    component: () => import(/* webpackChunkName: "Hr" */ "../components/Elearning/Genres.vue"),
    meta: { requiresAuth: true  ,requiresRoles: ['ROLE_Super_Admin', 'ROLE_CODING_ADMIN', 'ROLE_CODING_TEACHER']

    },
  },

  {
    path: "/interactive",
    name: "interactive",
    component: () => import(/* webpackChunkName: "Hr" */ "../components/Elearning/quizes.vue"),
    meta: { requiresAuth: true  ,requiresRoles: ['ROLE_Super_Admin', 'ROLE_CODING_ADMIN', 'ROLE_CODING_TEACHER']  },
  },

  {
    path: '/unauthorizedpage',
    name: 'unauthorizedpage',
    component: () => import(/* webpackChunkName: "Hr" */ "../components/Elearning/UnauthorizedPage.vue"),
  }
  ,

  // Elearning v2
  {
    path: "/elearning/exams",
    name: "ElearningExamManager",
    component: () => import(/* webpackChunkName: "Hr" */ "../components/elearningv2/ElearningExamManager.vue"),
    meta: { requiresAuth: true  ,requiresRoles: ['ROLE_Super_Admin', 'ROLE_All', 'ROLE_Elearning_Admin', 'ROLE_post_content']  },
  },

  {
    path: "/elearning/manage-questions/:id",
    name: "ManageQuestions",
    component: () => import(/* webpackChunkName: "Hr" */ "../components/elearningv2/ManageQuestions.vue"),
    meta: { requiresAuth: true  ,requiresRoles: ['ROLE_Super_Admin', 'ROLE_All', 'ROLE_Elearning_Admin', 'ROLE_post_content']  },
  },



  //Transport

  {
      path: "/transport",
      name: "TransportDashboard",
      component: () => import(/* webpackChunkName: "Transport" */ "../components/transport/transport-dashboard.vue"),
      meta: { requiresAuth: true, requiresRoles: [
        'ROLE_All',
        'ROLE_transport_admin',
        'ROLE_transport_operator',
        'ROLE_transport_view',
        'ROLE_transport_driver',
        'ROLE_transport_conductor',
        'ROLE_transport_parent',
        'ROLE_Parent',
      ] },
    },

    {
      path: "/transport/routes",
      name: "TransportRoutes",
      component: () => import(/* webpackChunkName: "Transport" */ "../components/transport/transport-routes.vue"),
      meta: { requiresAuth: true, requiresRoles: [
        'ROLE_All',
        'ROLE_transport_admin',
      ] },
    },

    {
      path: "/transport/pickup-points",
      name: "TransportPickupPoints",
      component: () => import(/* webpackChunkName: "Transport" */ "../components/transport/transport-pickup-points.vue"),
      meta: { requiresAuth: true, requiresRoles: [
        'ROLE_All',
        'ROLE_transport_admin',
      ] },
    },

    {
      path: "/transport/vehicles",
      name: "TransportVehicles",
      component: () => import(/* webpackChunkName: "Transport" */ "../components/transport/transport-vehicles.vue"),
      meta: { requiresAuth: true, requiresRoles: [
        'ROLE_All',
        'ROLE_transport_admin',
      ] },
    },

    {
      path: "/transport/operations",
      name: "TransportOperations",
      component: () => import(/* webpackChunkName: "Transport" */ "../components/transport/transport-operations.vue"),
      meta: { requiresAuth: true, requiresRoles: [
        'ROLE_All',
        'ROLE_transport_admin',
        'ROLE_transport_operator',
      ] },
    },



      {
      path: "/transport/assignments",
      name: "TransportAssignments",
      component: () => import(/* webpackChunkName: "Transport" */ "../components/transport/transport-assignments.vue"),
      meta: { requiresAuth: true, requiresRoles: [
        'ROLE_All',
        'ROLE_transport_admin',
        'ROLE_transport_operator',
      ] },
    },

    {
      path: "/transport/map",
      name: "TransportMap",
      component: () => import(/* webpackChunkName: "Transport" */ "../components/transport/transport-map.vue"),
      meta: { requiresAuth: true, requiresRoles: [
        'ROLE_All',
        'ROLE_transport_admin',
        'ROLE_transport_operator',
        'ROLE_transport_view',
      ] },
    },






    {
      path: "/transport/reports",
      name: "TransportReports",
      component: () => import(/* webpackChunkName: "Transport" */ "../components/transport/transport-reports.vue"),
      meta: { requiresAuth: true, requiresRoles: [
        'ROLE_All',
        'ROLE_transport_admin',
        'ROLE_transport_operator',
        'ROLE_transport_view',
      ] },
    },


    {
      path: "/transport/sms",
      name: "TransportSms",
      component: () => import(/* webpackChunkName: "Transport" */ "../components/transport/transport-sms.vue"),
      meta: { requiresAuth: true, requiresRoles: [
        'ROLE_All',
        'ROLE_transport_admin',
        'ROLE_transport_operator',
      ] },
    },

];


const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,

  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else if (to.hash) {
      // Safe hash-based scroll (e.g., #section2)
      return {
        el: to.hash,
        behavior: 'smooth',
      };
    } else {
      // Default to top
      return { top: 0 };
    }
  }

});



router.beforeEach((to, from, next) => {
  const authRequired = to.meta.requiresAuth === true;
  const isAuthenticated = store.getters.isAuthenticated || localStorage.getItem("authToken");
  const eleaningmainschoolname = localStorage.getItem('eleaningmainschoolname');

  // Clean up leftover modals
  const modalBackground = document.querySelector('.modal-backdrop');
  if (modalBackground) modalBackground.remove();

  if (authRequired && !isAuthenticated) {
    console.log("Redirecting to / due to missing auth");
    return next('/');
  }

  const requiredRoles = to.meta.requiresRoles;
  const allowedSchools = to.meta.allowedSchools;

  // 🚫 School-level access restriction
  if (allowedSchools && !allowedSchools.includes(eleaningmainschoolname)) {
    return next('/unauthorizedpage'); // Or any fallback page/component
  }

  // ✅ Role-based access restriction
  if (requiredRoles && to.path !== '/home') {
    const userRoles = Cookies.get('userRoles') || [];
    const parsedRoles = typeof userRoles === 'string' ? JSON.parse(userRoles) : userRoles;

    const hasRequiredRole = parsedRoles.some(userRole => requiredRoles.includes(userRole));
    if (!hasRequiredRole) {
      window.$('#myModalaccessdenied').modal('show'); // Bootstrap modal
      return; // Stop navigation
    }
  }

  next();
});





export default router;
